import React, { memo, ChangeEvent } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { QUOTE_TYPE_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  RATE_TYPE,
  ISpotBiddingConfig,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TextInput } from 'components/atoms'

interface IFuelDetailsProps {
  rateType?: RATE_TYPE
  fuelRpm?: string
  onChange(change: RecursivePartial<ISpotBiddingConfig>): void
}

export const FuelDetails = memo<IFuelDetailsProps>(({ fuelRpm, onChange, rateType }) => {
  const quoteTypeHandler = (e: ISelectOption<RATE_TYPE>) => {
    onChange({
      rateType: e.value as RATE_TYPE,
      fuelRpm: e.value === RATE_TYPE.linehaul ? fuelRpm : '',
    })
  }

  const fuelRpmHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    onChange({ fuelRpm: value })
  }
  return (
    <>
      <div className='col-md-3'>
        <Select
          label='Quote Type'
          placeholder='Select quote type'
          large
          options={QUOTE_TYPE_OPTIONS}
          value={rateType}
          onChange={quoteTypeHandler}
          dataTest='modal-quote-type'
        />
      </div>
      {rateType === RATE_TYPE.linehaul && (
        <div className='col-md-3'>
          <TextInput
            label='Fuel (per mile)'
            value={fuelRpm}
            large
            onChange={fuelRpmHandler}
            dataTest='modal-fuel-per-mile'
          />
        </div>
      )}
    </>
  )
})
